module.exports = __webpack_public_path__ + "media/application/images/ui/icon-external-link-90ac845038cd1e512496a14790caeb78.png";